(function() {

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-ES', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function getVariant(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return item.variant_title;
    }
    const opts = [item.option1, item.option2, item.option3]
      .filter(function(o) { return o && o !== 'Default Title'; });
    return opts.join(' · ');
  }

  function showToast(item) {
    if (!window.CartToast) return;
    const variant = getVariant(item);
    window.CartToast.show({
      title: (item.product_title || item.title || '—') + (variant ? ' · ' + variant : ''),
      price: formatMoney(item.final_price || item.price || 0),
      image: item.featured_image?.url || item.image || null
    });
  }

  // Interceptar todos los formularios add to cart
  // Evitar el redirect durante 2.5 segundos para que se vea el toast
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form.action || !form.action.includes('/cart/add')) return;

    e.preventDefault();
    e.stopPropagation();

    const formData = new FormData(form);
    const variantId = formData.get('id');
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: parseInt(formData.get('quantity')) || 1
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      showToast(item);
      // Redirigir al carrito después de 2.5s para que se vea el toast
      setTimeout(function() {
        window.location.href = '/cart';
      }, 2500);
    })
    .catch(function() {
      // Si falla, dejar que el formulario siga su curso normal
      form.submit();
    });
  }, true);

  // También interceptar fetch directo (para botones con JS propio del tema)
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const result = originalFetch.apply(this, arguments);
    if (typeof url === 'string' && url.includes('/cart/add') && !url.includes('.js') === false) {
      result.then(function(response) {
        const clone = response.clone();
        clone.json().then(function(data) {
          if (data && (data.title || data.items)) {
            const item = data.items ? data.items[0] : data;
            showToast(item);
          }
        }).catch(function() {});
      }).catch(function() {});
    }
    return result;
  };

  // Mostrar toast si hay datos pendientes (venimos de redirect)
  const pending = sessionStorage.getItem('cart_toast_pending');
  if (pending) {
    sessionStorage.removeItem('cart_toast_pending');
    try {
      const item = JSON.parse(pending);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          setTimeout(function() { showToast(item); }, 300);
        });
      } else {
        setTimeout(function() { showToast(item); }, 300);
      }
    } catch(e) {}
  }

})();